// User-friendly labels for all enum values
export const labels = {
  forWhom: {
    'myself': 'Myself',
    'someone-i-care-about': 'Someone I care about'
  },
  helpType: {
    'specialist': 'Talk to a specialist',
    'peer-group': 'Find a peer support group',
    'not-sure': 'Not sure yet'
  },
  concerns: {
    'sleep': 'Sleep problems',
    'stress-burnout': 'Stress / burnout',
    'anxiety-panic': 'Anxiety or panic',
    'trauma': 'Trauma or difficult experiences',
    'depression': 'Depression or low mood',
    'supporting-someone': 'Supporting someone else',
    'something-else': 'Something else'
  },
  occupationCategory: {
    'first-responder': 'First responder',
    'healthcare': 'Healthcare',
    'military-veteran': 'Military / Veteran',
    'student': 'Student',
    'office-professional': 'Office / professional',
    'trades-labour': 'Trades / labour',
    'not-working': 'Not working right now',
    'something-else': 'Something else'
  },
  firstResponderRole: {
    'police': 'Police',
    'fire': 'Fire',
    'paramedic': 'Paramedic',
    'dispatch': 'Dispatch',
    'corrections': 'Corrections',
    'search-rescue': 'Search & rescue',
    'other': 'Other'
  },
  provinces: {
    'AB': 'Alberta',
    'BC': 'British Columbia',
    'MB': 'Manitoba',
    'NB': 'New Brunswick',
    'NL': 'Newfoundland and Labrador',
    'NS': 'Nova Scotia',
    'NT': 'Northwest Territories',
    'NU': 'Nunavut',
    'ON': 'Ontario',
    'PE': 'Prince Edward Island',
    'QC': 'Quebec',
    'SK': 'Saskatchewan',
    'YT': 'Yukon'
  }
} as const;

// Screen microcopy
export const copy = {
  welcome: {
    title: "You're not alone",
    subtitle: "Let's connect you with the right support",
    button: 'Get started'
  },
  forWhom: {
    title: 'Who is this for?',
    subtitle: ''
  },
  helpType: {
    title: 'What kind of help are you looking for?',
    subtitle: ''
  },
  concerns: {
    title: "What's been going on?",
    subtitle: 'Select all that fit',
    button: 'Continue'
  },
  optionalNote: {
    title: 'Want to share a bit more?',
    subtitle: 'Totally optional',
    placeholder: "Anything you'd like us to know...",
    skipButton: 'Skip',
    continueButton: 'Share & continue'
  },
  occupation: {
    title: 'Which of these best fits you?',
    subtitle: ''
  },
  firstResponderDetail: {
    title: 'Which role?',
    subtitle: ''
  },
  location: {
    title: 'Where are you located?',
    provinceLabel: 'Province',
    cityLabel: 'City (optional)',
    cityPlaceholder: 'e.g., Calgary',
    button: 'Continue'
  },
  contact: {
    title: 'How can we reach you?',
    subtitle: "We'll only use this to reach out about your support request",
    nameLabel: 'Full name',
    namePlaceholder: 'Jane Doe',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    phoneLabel: 'Phone (optional)',
    phonePlaceholder: '(555) 123-4567',
    button: 'Continue'
  },
  review: {
    title: 'Looking good',
    subtitle: "Here's what we have so far",
    button: 'Submit & connect me',
    editButton: 'Edit',
    sections: {
      who: 'Who this is for',
      help: 'Type of support',
      concerns: "What's going on",
      note: 'Your note',
      occupation: 'Occupation',
      location: 'Location',
      contact: 'Contact info'
    }
  },
  confirmation: {
    title: "We've got your request",
    subtitle: 'Someone from our team will reach out soon',
    message: 'Check your email for next steps',
    button: 'Done'
  }
} as const;

// Validation messages
export const validation = {
  emailRequired: 'Email is required',
  emailInvalid: 'Please enter a valid email',
  nameRequired: 'Name is required',
  provinceRequired: 'Province is required',
  concernsRequired: 'Please select at least one',
  genericRequired: 'This field is required'
} as const;
